export default "__VITE_ASSET__7bd10e77__"